import React from 'react';
import {Button} from "react-bootstrap";
import {MutationAPI, useMutator} from "../../services/API";

const RunDistributionNowButton = ({id, size = 'sm', variant = 'primary', onSuccess, onRunningChange, disabled = false, compact = false}) => {
    const runDistribution = useMutator(MutationAPI.runDistributionNow, {
        customMsg: 'Raport został wygenerowany i wysłany',
        afterSuccess: onSuccess,
    });

    const handleClick = (event) => {
        if (event) {
            event.preventDefault();
            event.stopPropagation();
        }
        if (disabled || runDistribution.isLoading) {
            return;
        }
        if (onRunningChange) onRunningChange(true);
        runDistribution.mutate(id, {
            onSettled: () => {
                if (onRunningChange) onRunningChange(false);
            }
        });
    }

    const isLoading = runDistribution.isLoading;

    if (compact) {
        return <Button size={size} variant="link" disabled={disabled || isLoading} onClick={handleClick} title="Uruchom teraz" className="action-icon-btn action-run">
            <i className={`fas ${isLoading ? 'fa-spinner fa-spin' : 'fa-play'}`}/>
            <span>{isLoading ? 'Uruchamianie' : 'Uruchom'}</span>
        </Button>
    }

    return <Button size={size} variant={variant} disabled={disabled || isLoading} onClick={handleClick}>
        {isLoading ? 'Uruchamianie...' : 'Uruchom teraz'}
    </Button>
}

export default RunDistributionNowButton;

